import { compact } from 'lodash'

import { AgentAttendanceDetails } from 'modules/Monitoring/types'

import { AgentAttendanceFormattedData, AgentAttendanceShiftState } from '../types'

import { getCurrentShiftPosition } from './getCurrentShiftPosition'
import { getShiftPositionStatus } from './getShiftPositionStatus'

export const prepareTableData = (
  data: AgentAttendanceDetails[],
): AgentAttendanceFormattedData[] => {
  return data.map(({ agent, shift, assignedTicketCount }) => {
    const { currentPosition, activePosition } = getCurrentShiftPosition(shift.positions)

    return {
      agent,
      assignedTicketCount,
      shiftId: shift.id,
      specialisation: currentPosition?.name ?? '',
      startDate: currentPosition?.startDate ?? shift.startDate,
      endDate: currentPosition?.endDate ?? shift.endDate,
      currentStatus: activePosition ? agent.currentStatus : undefined,
      productive: currentPosition?.productive ?? true,
      labels: [...new Set(shift.positions.flatMap(position => position.labels))].sort(),
      metrics: {
        activeTime: activePosition?.metrics?.activeTime ?? shift.metrics?.activeTime,
        adherence: activePosition?.metrics?.adherence ?? shift.metrics?.adherence,
      },

      subRows: compact(
        shift.positions.map(position => {
          const positionStatus = getShiftPositionStatus(position)

          return positionStatus === AgentAttendanceShiftState.Active
            ? undefined
            : {
                agent,
                shiftId: shift.id,
                specialisation: position.name,
                startDate: position.startDate,
                endDate: position.endDate,
                currentStatus: positionStatus,
                productive: position.productive,
                labels: position.labels.sort(),
                metrics: {
                  activeTime: position.metrics?.activeTime,
                  adherence: position.metrics?.adherence,
                },
              }
        }),
      ),
    }
  })
}
